import { render, staticRenderFns } from "./VoiceCall.vue?vue&type=template&id=c37ff158&scoped=true&"
import script from "./VoiceCall.vue?vue&type=script&lang=js&"
export * from "./VoiceCall.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCall.vue?vue&type=style&index=0&id=c37ff158&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37ff158",
  null
  
)

export default component.exports